import { Routes, Route, Navigate } from "react-router-dom";
import SupplyPage from "../pages/Supply/SupplyPage";
import SupplyRequisiton from "../pages/Supply/SupplyRequisition/SupplyRequisitionPage";
import InventoryMoviment from "../pages/Supply/InventoryMoviment/InventoryMovimentPage";
import OrdersPage from "../pages/Supply/Orders/OrdersPage";
import NecessitiesPage from "../pages/Supply/Necessities/NecessitiesPage";

const SupplyRoutes: React.FC = () => {
  return (
    <Routes>
      <Route index element={<SupplyPage />} />
      <Route path="/requisition" element={<SupplyRequisiton />} />
      <Route path="/moviment" element={<InventoryMoviment />} />
      {/*
        Compras (§10.5). A `LeftBar` já prometia "Compras → Ordens" e a rota não
        existia — o item do menu levava ao `Navigate to="../"` abaixo, e o dono
        clicava e voltava para o índice sem nenhuma explicação.
      */}
      <Route path="/orders" element={<OrdersPage />} />
      <Route path="/necessities" element={<NecessitiesPage />} />
      <Route path="/*" element={<Navigate to="../" />} />
    </Routes>
  );
};

export default SupplyRoutes;
